import React, {useState, useEffect} from "react";
import tw from "twin.macro";
import ReactPlayer from 'react-player';
import Modal from 'react-modal';
import styled from "styled-components";
//components
import {Container} from "components/misc/Layouts";
import Footer from "components/Footer";
import Hero from "components/headers/light";
//icons
import {AiOutlineClose} from "react-icons/ai";
import {ReactComponent as StarIcon} from "feather-icons/dist/icons/star.svg";
import ReadMoreButton from "components/ReadMoreButton.js";
//utility
import {useAppDispatch, loadTrailer, loadMoreTrailer, useAppSelector} from "../redux";
import AdComponent from '../components/AdComponent.js';
const Text = tw.div` text-xs  text-gray-600`;
const Year = tw.div`ml-2  text-xs line-clamp-1  flex text-right text-yellow-600`;
const TextInfo = tw.div`mx-2 md:mt-2 lg:mt-0 mt-0 p-2 md:p-0 bg-yellow-50`;
const TitleReviewContainer = tw.div`flex flex-row justify-between items-center xsm:-mt-2 lg:mt-0`;
const Title = tw.h5`lg:text-sm text-xs font-semibold line-clamp-1`;
const PlayImage = tw.img`w-16 h-16 mx-auto p-2 hover:p-1`;
const Rating = tw.span`ml-2 text-sm font-bold`;
const IconWithText = tw.div`flex items-center`;
const Card = tw.div`mx-auto xl:mx-0 xl:ml-auto max-w-sm  lg:p-5 md:max-w-xs lg:max-w-sm xl:max-w-xs`;
const Heading = tw.text`text-2xl font-bold  text-gray-900`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl min-h-screen xsm:px-2 pb-10 w-full mx-auto pt-24`;
const One = tw.div`max-w-screen-xl grid grid-cols-2 gap-1 md:grid-cols-3 md:gap-3 lg:grid-cols-6 lg:gap-4 xsm:mt-2 lg:mx-2 lg:mt-2 px-1`;
const Root = tw.div`lg:flex `;
const Div = tw.div`w-full mx-auto px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;
const DivFlex = tw.div`flex justify-end items-center cursor-pointer pb-4 pr-2`;
const Hr = tw.hr`mt-2`;

const CardImage = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`lg:h-72 lg:w-48 md:h-80 md:w-64 h-56 w-40 flex items-center justify-center bg-cover bg-center rounded`,
]);
const YearInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-5 h-5 text-yellow-500 fill-current`}
  }
`;
const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`lg:w-6 lg:h-6 w-3 h-3 text-yellow-500 fill-current`}
  }
`;

export default ({headingText = "Trailers"}) => {
  const dispatch = useAppDispatch();

  const trailer = useAppSelector(state => state.trailer.trailer);
  const isEndReached = useAppSelector(state => state.trailer.isEndReached);
  //const [movieTrailer, setMovieTrailer] = useState([])
  const [open, setOpen] = useState(false);
  const [getUrl, setGetUrl] = useState("");


  useEffect(() => {
    if (trailer.length === 0) {
      dispatch(loadTrailer());
    }
  }, [dispatch]);

  const customStyles = {
    content: {
      top: '55%',
      left: '10%',
      right: '10%',
      bottom: '-40%',
      marginRight: '-40%',
      marginLeft: '40%',
      transform: 'translate(-50%, -50%)',
      overflow: 'hidden',

    }
  };

  const handleLoadMoreData = () => {
    dispatch(loadMoreTrailer());
  };

  const ModalOpen = (value) => {
    setOpen(true);
    setGetUrl(value);
  };


  return (
    <>
      <Div>
        <Hero />
        <Hr />
      </Div>
      <Container>
        <AdComponent />
        <ContentWithPaddingXl>
          <Heading>{headingText}</Heading>
          <Root>
            <One>
              {trailer && trailer.map((item) => (
                <Card key={item.id}>

                  <CardImage imageSrc={item.cover_url} >
                    <PlayImage onClick={() => ModalOpen(item.trailer)} src={require("../images/flximg/playButton.svg")} />
                  </CardImage>
                  <TextInfo>
                    <TitleReviewContainer>
                      <Title>{item.title}</Title>
                      {item.rating ? <RatingsInfo>
                        <StarIcon />
                        <Rating>{item.rating}</Rating>
                      </RatingsInfo> : <text></text>}
                    </TitleReviewContainer>

                    <TitleReviewContainer>
                      {item.genre ? <IconWithText>
                        <Text>{item.genre}</Text>
                      </IconWithText> : <text></text>}
                      <YearInfo>
                        <Year>{item.release_date}</Year>
                      </YearInfo>
                    </TitleReviewContainer>

                  </TextInfo>
                </Card>

              ))}
            </One>
          </Root>
          {isEndReached ? null : <ReadMoreButton handleLoadMoreData={handleLoadMoreData} />}
        </ContentWithPaddingXl>
      </Container>






      <div>
        <Modal isOpen={open}
          style={customStyles}>
          <DivFlex>
            <AiOutlineClose className="cursor-pointer" onClick={() => open ? setOpen(!open) : setOpen(open)} />
          </DivFlex>
          <ReactPlayer
            width="100%"
            height="95%"
            controls
            url={getUrl}
          />

        </Modal>
      </div>
      <Footer />

    </>
  );
};
